import { render, staticRenderFns } from "./FiltersDiagnostics.vue?vue&type=template&id=3f84e508&scoped=true"
import script from "./FiltersDiagnostics.vue?vue&type=script&lang=js"
export * from "./FiltersDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./FiltersDiagnostics.vue?vue&type=style&index=0&id=3f84e508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84e508",
  null
  
)

export default component.exports